import { optionIdSymbol, typeSymbol } from './engine-impl.js';
import { BigNumber, MLString } from './types.js';
import SearchCriteriaBuilder from './DataSetService/SearchCriteriaBuilder.js';
export { AutoCorrectPropertyEvent } from './services/notifications/AutoCorrectModelEvents.js';
export { ExternalFieldRegistry } from './services/ExternalFieldRegistry.js';
export { LanguageService } from './services/LanguageService.js';
export { engineUtils } from './services/EngineUtils.js';
export { Schema, SchemaTypeRef } from './schema.js';
export { deepCopy } from './deep-copy.js';
export { PrimitiveType, SystemType, Type, TypeKind } from './types.js';
export { PropertyPathWalker } from './internal/PropertyPathWalker.js';
export { ModelSystemProperties } from './internal/ModelSystemProperties.js';
export { Option, OptionGroup, SourcedValue } from './option.js';
export { YamlDatasetService } from './DataSetService/YamlDatasetService.js';
export { Product, ProductGroup } from './product.js';
export { ObjectType, ListType, EnumType, UnionType, Property, MLString, BigNumber } from './types.js';
export { ValidationResult } from './engine.js';
export { SinglePropertyMutator } from './internal/SinglePropertyMutator.js';
export { TransactionalMutator } from './internal/TransactionalMutator.js';
export { PrototypeTraverser, SimpleVisitor } from './internal/PrototypeVisitor.js';
export { APIResult, PluginBase } from './plugin.js';
export { ConstraintInstance } from './constraint.js';
export { ModelErrorCode } from './errors/ModelError.js';
export { FlatStructuralTransformer } from './services/transformers/FlatStructuralTransformer.js';
export { IdentityStructuralTransformer } from './services/transformers/IdentityStructuralTransformer.js';
export { FlatProductTransformer, HierarchicalProductTransformer } from './services/transformers/ProductTransformer.js';
export { LookupMutator } from './mutators/LookupMutator.js';
export { JsExpressionConstraint } from './constraint.js';
export { SearchCriteriaBuilder };
export { ModelNotificationEvent } from './services/notifications/ModelNotificationEvent.js';
export { LookupMutatorCorrectionEvent } from './services/notifications/LookupMutatorCorrectionEvent.js';
export function useTypeFrom(o1, o2) {
    o1[typeSymbol] = o2[typeSymbol];
}
export function getTypeRef(o) {
    if (typeof o === 'string') {
        return 'string';
    }
    if (typeof o === 'number') {
        return 'number';
    }
    if (typeof o === 'boolean') {
        return 'boolean';
    }
    if (o instanceof MLString) {
        return 'mlstring';
    }
    if (o instanceof BigNumber) {
        return 'bignumber';
    }
    return o[typeSymbol];
}
export function getOptionId(o) {
    return o ? o[optionIdSymbol] : undefined;
}
export const getProductId = getOptionId;
export const getProductGroupId = getProductId;
export { EngineImpl as Engine, EngineInternalAPI, typeSymbol } from './engine-impl.js';
export { ObjectHashSet } from './lookup/ObjectHashSet.js';
export { AsyncJsDatasetService } from './DataSetService/AsyncJsDatasetService.js';
export { AsyncYamlDatasetService } from './DataSetService/AsyncYamlDatasetService.js';
//# sourceMappingURL=index.js.map